import "./NutraceuticalAndCosmetic.module.css";
import Header from "@/reusable_sections/Header";
import NutraceuticalHero from "./sections/NutraceuticalHero";
import ApplicationAreas from "./sections/ApplicationAreas";
import ProcessOverview from "./sections/ProcessOverview";
import SupportServices from "./sections/SupportServices";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function NutraceuticalAndCosmeticPage() {
  return <div>
      <Header />
      <NutraceuticalHero />
      <ApplicationAreas />
      <ProcessOverview />
      <SupportServices />
      <CallToAction />
      <Footer />
    </div>;
}